import React from 'react'
import PropTypes from 'prop-types'
import CustomLink from '../customLink'
import { ButtonArrow } from '../ctIcons'
import styles from './style.module.scss'
function CardBottomButton({ text, link, internalLink = false }) {
  return (
        <div className={`${styles.container} text-center d-flex`}>
            {
                internalLink ? <CustomLink href={link} prefetch={false}>
                <a className="theme-btn btn btn-primary w-100">
                 {text || 'Watch More'}
                  <ButtonArrow />
                </a>
              </CustomLink> : <a href={link} className="theme-btn btn btn-primary w-100">
              {text || 'Watch More'}
              <ButtonArrow />
            </a>
            }
        </div>
  )
}

CardBottomButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  link: PropTypes.string,
  internalLink: PropTypes.bool
}

export default CardBottomButton
